import { Box, Button, colors, Container, Divider, Hidden, Stack, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import HeaderSDG from '../../components/HeaderSDG';

const headerBackground = { background: `linear-gradient(123deg, rgba(0,194,109,1) 0%, rgba(66,165,245,1) 40%, rgba(187,222,251,1) 100%);` };

const Information = () => {
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.up('sm'));
  const navigate = useNavigate();
  return (
    <Stack direction='column' sx={{ backgroundColor: 'white', minHeight: '100vh' }}>
      <Stack direction='column' justifyContent='space-between'>
        {/* <MenuDrawer anchor={anchor} /> */}
        <HeaderSDG />
        <Container sx={{ backgroundColor: 'white', minHeight: '100vh' }}>
          <Stack direction='column' spacing={2} p={2}>
            <Box>
              <Button variant='outlined' onClick={() => navigate('/')}>
                Dashboard
              </Button>
            </Box>
            <Divider />
            <Typography variant='h5'>Introduction</Typography>
            <Typography variant='body2'>
              Welcome to the the United Nations in Indonesia‘s Document Repository (DOMES) which aims to create a one-stop-shop for the latest research,
              assessments, reports, used cases, policy briefs, working papers, case studies, documentation of good practices, and human interest stories on
              various development topics, including on the social and economic impacts of the COVID-19 Pandemic, Sustainable Development Goals and the UN
              Sustainable Development Cooperation Framework (UNSDCF). It will house, visualize and provide easy access to the information and knowledge produced
              or supported by UN agencies.
            </Typography>
            <Typography variant='body2'>
              This repository makes them available to the wider public with the goal to create knowledge-sharing opportunities to:
            </Typography>
            <Stack sx={{ paddingLeft: 4 }}>
              <ul>
                <li>
                  <Typography variant='body2'>Understand the breadth of UN-supported research, studies and assessments in Indonesia;</Typography>
                </li>
                <li>
                  <Typography variant='body2'>Track the progress in line with the 2030 Agenda for Sustainable Development;</Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    Support evidence based decisions for program design and implementation across UN agencies and programmes as well as for government and
                    development stakeholders;
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>Identification and analysis of knowledge gaps in Sustainable Development; and</Typography>
                </li>
                <li>
                  <Typography variant='body2'>
                    Increase collaboration and synergies among UN Country Team in Indonesia, government, and development stakeholders in the area of research
                    and assessments
                  </Typography>
                </li>
              </ul>
            </Stack>
            <Divider />
            <Typography variant='h5'>How to submit new documents?</Typography>
            <Typography variant='body2'>
              If you wish to share your documents or information about your anticipating documents, please kindly complete all relevant information and upload
              the document in the online form.
            </Typography>
            <Typography variant='body2'>The documents that are within the scope of the repository are:</Typography>
            <Stack sx={{ paddingLeft: 4 }}>
              <ul>
                <li>
                  <Typography variant='body2'>
                    Produced and/or supported by UN agencies in Indonesia (Including World Bank, IMF and Non Resident agencies). This is translated into the use
                    of a UN logo, acknowledgement or otherwise.
                  </Typography>
                </li>
                <li>
                  <Typography variant='body2'>Focussing fully or partially on Indonesia.</Typography>
                </li>
              </ul>
            </Stack>
            <Typography variant='body2'>
              By submitting a document such as a report, publication, assessment or another sort of document, the UN Resident Coordinator’s Office will have
              full consent to read and access the document. In the submission form, the UN agency is requested for additional consent to make the document
              available to the public and published through the UN Documents Repository. Documents that are only available for internal use (not for external
              publication) will be stored at the UN Indonesia internal repository (MS SharePoint).
            </Typography>
            <Typography variant='body2'>
              If you need further information, please kindly contact the RCO at: erlangga.landiyanto@un.org and mega.puspitasari@un.org
            </Typography>
            <Divider />
            <Typography variant='h5'>Disclaimer</Typography>
            <Typography variant='body2'>
              The responsibility for opinions expressed in the documents rests solely with their authors. Publication in this portal does not constitute an
              endorsement by the United Nations of the opinions expressed in them.
            </Typography>
            <Typography variant='body2'>
              The designations and the presentation of the materials used by the documents in this portal, including their respective citations, maps and
              bibliography, do not imply the expression of any opinion whatsoever on the part of the United Nations concerning the legal status of any country,
              territory, city or area or of its authorities, or concerning the delimitation of its frontiers or boundaries.
            </Typography>
            <Typography variant='body2'>
              Also, the boundaries and names shown and the designations used in the documents or reports in this portal do not imply official endorsement or
              acceptance by the United Nations.
            </Typography>
            <Typography variant='body2'>
              Any information that may be contained in the documents or reports in this portal emanating from actions and decisions taken by the government,
              civil society, private sectors, NGOs and development partners does not imply recognition by the United Nations of the validity of the actions and
              decisions in question.
            </Typography>
          </Stack>
        </Container>
      </Stack>
    </Stack>
  );
};

export default Information;
